import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DashboardService } from '../service';

@Component({
  selector: 'fa-kt-dashboard-detail',
  templateUrl: './dashboard-detail.component.html',
  styleUrls: ['./dashboard-detail.component.css'],
})
export class DashboardDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public dashboard: DashboardService) {}
}
